module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "footer",
    attrs: {
      "role": "footer",
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container",
    on: {
      "click": function($event) {
        return _vm.mostraRodape()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3 hidden-xs info-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v("PROBLEMAS")]), _vm._v(" "), _c('p', [_vm._v("\n          Abra um SAU para"), _c('br'), _vm._v("solucionar seu problema."), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/sau"
    }
  }, [_vm._v("\n            egov.santos.sp.gov.br/sau\n          ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3 hidden-xs info-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v("DEGEPAT")]), _vm._v(" "), _c('p', [_vm._v("\n          Rua QUINZE DE NOVEMBRO, 108"), _c('br'), _vm._v("\n          Centro - Santos/SP"), _c('br'), _vm._v("\n          CEP 11010-150"), _c('br'), _vm._v("\n          Tel. (13) 3213-7166"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:degepat@santos.sp.gov.br"
    }
  }, [_vm._v("\n            degepat@santos.sp.gov.br\n          ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-3 hidden-xs info-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v("CONTROLADORIA")]), _vm._v(" "), _c('p', [_vm._v("\n          Paço Municipal"), _c('br'), _vm._v("\n          Praça Visconde de Mauá, s/n"), _c('br'), _vm._v("\n          3º andar, sala 302"), _c('br'), _vm._v("\n          Cep 11010-900"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:declaracaodebens@santos.sp.gov.br"
    }
  }, [_vm._v("\n            declaracaodebens@santos.sp.gov.br\n          ")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-xs-6 visible-xs info-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v("PROBLEMAS")]), _vm._v(" "), _c('p', [_vm._v("\n            Abra um SAU para"), _c('br'), _vm._v("solucionar seu problema."), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/sau"
    }
  }, [_vm._v("\n              egov.santos.sp.gov.br/sau\n            ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row row-field"
  }, [_c('div', {
    staticClass: "col-xs-6 visible-xs info-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v("DEGEPAT")]), _vm._v(" "), _c('p', [_vm._v("\n            Rua Riachuelo, 104"), _c('br'), _vm._v("\n            Centro - Santos/SP"), _c('br'), _vm._v("\n            Cep 11010-020"), _c('br'), _vm._v("\n            Tel. (13) 3213-7166"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:degepat@santos.sp.gov.br"
    }
  }, [_vm._v("\n              degepat@santos.sp.gov.br\n            ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 visible-xs info-content"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('h4', [_vm._v("IPREV")]), _vm._v(" "), _c('p', [_vm._v("\n            Rua Dr. Assis Corrêa, 20"), _c('br'), _vm._v("\n            Gonzaga - Santos/SP"), _c('br'), _vm._v("\n            Cep 11055-310"), _c('br'), _vm._v("\n            Tel. (13) 3202-9099"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:degepat@santos.sp.gov.br"
    }
  }, [_vm._v("\n              iprev@santos.sp.gov.br\n            ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n        Prefeitura de Santos - Secretaria de Gestão (SEGES) - Departamento de\n        Gestão de Tecnologia da Informação e Comunicação (DETIC) - Versão:\n        3.0.0 - 2019\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42514e88","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rodape/index.vue
// module id = NVyW
// module chunks = 5